<app-header [label]="page_name | plural"></app-header>
<div class="flex bg-white gap-4 items-center justify-between p-4 border-b border-gray-300">
  <app-search-input #searchbar></app-search-input>
  <app-dropdown-upload-button [page_name]="page_name" (bulkUpload)="bulk_modal.open()" (singleUpload)="open_form_modal()"> </app-dropdown-upload-button>
</div>
<app-ag-grid-list [list]="items" [colDefs]="city_cols" [itemName]="page_name" (fetch_new_list)="get_list($event)" (bulkDelete)="bulk_delete($event)">
</app-ag-grid-list>
<app-confirmation-popup #confirmation_delete_modal label="Delete {{page_name}}?" [delete_icon]="true" cancelText="No" confirmColor="bg-[#FA2912] text-[#FFFFFF]" confirmText="Yes" [is_mandatory]="true" (confirm_modal_clicked)="delete_university()" (close_modal_clicked)="confirmation_delete_modal.close()">
  Are you sure you want to Permanently delete the selected record ? This cannot be undone
</app-confirmation-popup>
<app-confirmation-popup #confirmation_disabled_modal [enable_icon]="selected_ids.is_active == true ? false : true" [disabled_icon]="selected_ids.is_active == false ? false : true" confirmColor="bg-[#FA2912] text-[#FFFFFF]" [is_mandatory]="true" (confirm_modal_clicked)="update_country(selected_ids.is_active)" (close_modal_clicked)="confirmation_disabled_modal.close()">
  Are you sure you want to {{selected_ids.is_active == true? "Disable" :"Enable"}} School
</app-confirmation-popup>
<app-modal #form_modal [label]="`${selected_ids.id ? 'Update' : 'Add'} ${page_name}`">
  <form [formGroup]="form">
    <div class="py-2 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
      <app-select-input label="Country" class="w-full" [is_required]="true" [depended]="1" formControlName="country_id" [options]="ds.dropdown_list?.country_list" (valueChange)="gs.onDropdownChange($event)" (registerSelf)="gs.registerDropdown($event)"></app-select-input>
      <app-select-input label="State" class="w-full" [is_required]="true" [depended]="2" formControlName="state_id" [options]="ds.dropdown_list?.state_list | filterByKeyAndValue : 'country.id' :form.get('country_id')?.value" (valueChange)="gs.onDropdownChange($event)" (registerSelf)="gs.registerDropdown($event)"></app-select-input>
      <app-select-input [is_required]="true" label="District" class="w-full" formControlName="district_id" [depended]="3" [options]="(form.get('country_id')?.value && form.get('state_id')?.value) ? (ds.dropdown_list?.district_list | filterByKeyAndValue : 'state_id' : form.get('state_id')?.value) : []" [disabled]="!form.get('country_id')?.value || !form.get('state_id')?.value" (valueChange)="gs.onDropdownChange($event)" (registerSelf)="gs.registerDropdown($event)">
      </app-select-input>
      <app-select-input label="City" class="w-full" [is_required]="true" formControlName="city_id" [depended]="4" [options]="ds.dropdown_list?.city_list | filterByKeyAndValue : 'district_id' :form.get('district_id')?.value | filterByKeyAndValue : 'District.State.id' :form.get('state_id')?.value" (valueChange)="gs.onDropdownChange($event)" (registerSelf)="gs.registerDropdown($event)"></app-select-input>
      <app-text-input [is_required]="true" class="w-full" [label]="page_name + ' Name'" formControlName="name"></app-text-input>
      <app-text-input [is_required]="true" class="w-full" [label]="'Code'" formControlName="code"></app-text-input>
      <app-text-input type="email" [is_required]="true" class="w-full" [label]=" ' Email ID'" formControlName="email"></app-text-input>
      <app-text-input type="number" [is_required]="true" type_total_latter="12" class="w-full" [label]=" ' Contact Number'" formControlName="contact"></app-text-input>
      <app-text-input [is_required]="true" class="w-full" [label]=" ' Address'" formControlName="address"></app-text-input>
    </div>
    <div class="flex justify-end items-center gap-2 mt-2">
      <app-button color="border-primary text-primary" label="Cancel" type="button" (click)="close_form_modal()"></app-button>
      <app-button color="bg-secondary text-black" [label]="selected_ids.id ? 'Update' :'Add'" type="button" [disabled]="isSubmitting" [submit]="submit.bind(this)"></app-button>
    </div>
  </form>
</app-modal>
<app-modal #bulk_modal label="Bulk Upload {{page_name | plural}}" sub_label="Add {{ page_name }} in Bulk">
  <app-bulk-upload [title]="page_name" [cancel]="bulk_modal" [accepted_type]="['.csv']" [max_file_sizeMB]="5" [bulk_columns]="bulk_columns" (submit)="bulk_upload($event.data,$event.spinner)"></app-bulk-upload>
</app-modal>
<app-modal #view_modal [label]="'View ' + page_name" width="lg">
  <div class="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Country Name</p>
      <p class="text-gray-900 mt-1 text-wrap truncate">{{ selected_ids?.City?.District?.State?.country?.name || '—' }}
      </p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">State Name</p>
      <p class="text-gray-900 mt-1 text-wrap truncate">{{ selected_ids?.City?.District?.State?.name || '—' }}</p>
    </div>
    <!-- <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">Division Name</p>
            <p class="text-gray-900 mt-1 text-wrap truncate">{{ selected_ids?.City?.District?.Division?.name || '—' }}</p>
        </div> -->
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">District Name</p>
      <p class="text-gray-900 mt-1 text-wrap truncate">{{ selected_ids?.City?.District?.name || '—' }}</p>
    </div>
    <!-- <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">Taluka Name</p>
            <p class="text-gray-900 mt-1 text-wrap truncate">{{ selected_ids?.City?.Taluka?.name || '—' }}</p>
        </div> -->
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">City Name</p>
      <p class="text-gray-900 mt-1 text-wrap truncate">{{ selected_ids?.City?.name || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">{{page_name}} Name</p>
      <p class="text-gray-900 mt-1 text-wrap truncate">{{ selected_ids?.name || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Code</p>
      <p class="text-gray-900 mt-1 text-wrap truncate">{{ selected_ids?.code || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Email</p>
      <p class="text-gray-900 mt-1 text-wrap truncate">{{ selected_ids?.email || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Contact Number</p>
      <p class="text-gray-900 mt-1 text-wrap truncate">{{ selected_ids?.contact || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Address</p>
      <p class="text-gray-900 mt-1 text-wrap truncate">{{ selected_ids?.address || '—' }}</p>
    </div>


  </div>
</app-modal>